import styled from 'styled-components';

const MobileLayout = styled.div`
	margin-bottom: ${(props) => props.theme.spacing(10)};
`;

export default MobileLayout;
